import NoSleep from 'nosleep.js'

// Vendor-prefixed variants, absent from TypeScript's DOM lib.
type PrefixedElement = HTMLElement & {
  mozRequestFullScreen?: () => void
  webkitRequestFullscreen?: () => void
  msRequestFullscreen?: () => void
}

type PrefixedDocument = Document & {
  mozCancelFullScreen?: () => void
  webkitExitFullscreen?: () => void
  msExitFullscreen?: () => void
}

const noSleep = new NoSleep()

/**
 * Fullscreen and wake lock are permissions, not guarantees. iOS in particular
 * rejects them, and an unhandled rejection is worse than no fullscreen.
 */
function ignoreDenied(promise: Promise<unknown> | undefined) {
  if (promise) void promise.catch(() => {})
}

/**
 * Fullscreen the whole document, holding a wake lock while it is active so
 * output displays don't sleep mid-show.
 */
export function toggleFullscreen() {
  const element = document.documentElement as PrefixedElement
  const doc = document as PrefixedDocument

  if (!doc.fullscreenElement) {
    if (element.requestFullscreen) {
      ignoreDenied(element.requestFullscreen())
    } else if (element.mozRequestFullScreen) {
      // Firefox
      element.mozRequestFullScreen()
    } else if (element.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      element.webkitRequestFullscreen()
    } else if (element.msRequestFullscreen) {
      // IE/Edge
      element.msRequestFullscreen()
    }
    ignoreDenied(noSleep.enable())
  } else {
    if (doc.exitFullscreen) {
      ignoreDenied(doc.exitFullscreen())
    } else if (doc.mozCancelFullScreen) {
      doc.mozCancelFullScreen()
    } else if (doc.webkitExitFullscreen) {
      doc.webkitExitFullscreen()
    } else if (doc.msExitFullscreen) {
      doc.msExitFullscreen()
    }
    noSleep.disable()
  }
}
